<kendo-dialog-titlebar>
    <fa-icon icon="triangle-exclamation" class="k-mr-2" style="font-size: 24px;"></fa-icon>
    <span>{{ title }}</span>
</kendo-dialog-titlebar>
<kendo-dialog-messages>
    Some issues were found with your selection. Please review and resolve them below. Actions cannot proceed with
    existing errors.
</kendo-dialog-messages>
<kendo-grid [data]="issues" class="k-mt-4">
    <kendo-grid-column field="type" title="Issue Type" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span [ngClass]="{'warning': dataItem.type === 'Warning', 'error': dataItem.type === 'Error'}">{{
                dataItem.type }}</span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="description" title="Description">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="issue-description" [textContent]="dataItem.description"></div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="description" title="Student/Mandate">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div></div>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>
<!-- <kendo-dialog-actions>
    <div class="k-d-flex k-justify-content-between">
        <button kendoButton (click)="onCancel()" themeColor="primary" fillMode="outline">{{ cancelText }}</button>
        <button kendoButton (click)="onConfirm()" themeColor="primary" fillMode="solid">{{ confirmText }}</button>
    </div>
</kendo-dialog-actions> -->